/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_167_TitleInputs */

const en_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blueberry Macaron`)
};

const ar_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماكارون التوت الأزرق`)
};

const de_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blaubeer-Macaron`)
};

const es_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de arándano`)
};

const fr_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron à la myrtille`)
};

const it_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron al mirtillo`)
};

const ja_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブルーベリーマカロン`)
};

const ko_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`블루베리 마카롱`)
};

const pt_br_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de Mirtilo`)
};

const ru_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черничный макарон`)
};

const th_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาการองบลูเบอร์รี`)
};

const tr_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaban Mersinli Makaron`)
};

const zh_cn_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蓝莓马卡龙`)
};

const zh_tw_tree_type_167_title = /** @type {(inputs: Tree_Type_167_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`藍莓馬卡龍`)
};

/**
* | output |
* | --- |
* | "Blueberry Macaron" |
*
* @param {Tree_Type_167_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_167_title = /** @type {((inputs?: Tree_Type_167_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_167_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_167_title(inputs)
	if (locale === "ar") return ar_tree_type_167_title(inputs)
	if (locale === "de") return de_tree_type_167_title(inputs)
	if (locale === "es") return es_tree_type_167_title(inputs)
	if (locale === "fr") return fr_tree_type_167_title(inputs)
	if (locale === "it") return it_tree_type_167_title(inputs)
	if (locale === "ja") return ja_tree_type_167_title(inputs)
	if (locale === "ko") return ko_tree_type_167_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_167_title(inputs)
	if (locale === "ru") return ru_tree_type_167_title(inputs)
	if (locale === "th") return th_tree_type_167_title(inputs)
	if (locale === "tr") return tr_tree_type_167_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_167_title(inputs)
	return zh_tw_tree_type_167_title(inputs)
});